import React from "react";
import "./Personalise_Gift_Swiper.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faThumbsUp } from "@fortawesome/free-regular-svg-icons";

const Personalise_Gift_Swiper = () => {
  const data = [
    {
      img: "/assest/luxury_images/gift_customisation/img1.png",
      title: "Digital Mockup",
      descn: "A digital .pdf mockup of your logo/ design on this product",
      recieveText: "2 to 48 hrs",
      reccomend:
        "you’re still ideating or want to share with your team for approval",
    },
    {
      img: "/assest/luxury_images/gift_customisation/img2.png",
      title: "Digital Mockup",
      descn: "A digital .pdf mockup of your logo/ design on this product",
      recieveText: "2 to 48 hrs",
      reccomend:
        "you’re still ideating or want to share with your team for approval",
    },
    {
      img: "/assest/luxury_images/gift_customisation/img1.png",
      title: "Digital Mockup",
      descn: "A digital .pdf mockup of your logo/ design on this product",
      recieveText: "2 to 48 hrs",
      reccomend:
        "you’re still ideating or want to share with your team for approval",
    },


     {
      img: "/assest/luxury_images/gift_customisation/img1.png",
      title: "Digital Mockup",
      descn: "A digital .pdf mockup of your logo/ design on this product",
      recieveText: "2 to 48 hrs",
      reccomend:
        "you’re still ideating or want to share with your team for approval",
    },
    {
      img: "/assest/luxury_images/gift_customisation/img2.png",
      title: "Digital Mockup",
      descn: "A digital .pdf mockup of your logo/ design on this product",
      recieveText: "2 to 48 hrs",
      reccomend:
        "you’re still ideating or want to share with your team for approval",
    },
    {
      img: "/assest/luxury_images/gift_customisation/img1.png",
      title: "Digital Mockup",
      descn: "A digital .pdf mockup of your logo/ design on this product",
      recieveText: "2 to 48 hrs",
      reccomend:
        "you’re still ideating or want to share with your team for approval",
    },


     {
      img: "/assest/luxury_images/gift_customisation/img1.png",
      title: "Digital Mockup",
      descn: "A digital .pdf mockup of your logo/ design on this product",
      recieveText: "2 to 48 hrs",
      reccomend:
        "you’re still ideating or want to share with your team for approval",
    },
    {
      img: "/assest/luxury_images/gift_customisation/img2.png",
      title: "Digital Mockup",
      descn: "A digital .pdf mockup of your logo/ design on this product",
      recieveText: "2 to 48 hrs",
      reccomend:
        "you’re still ideating or want to share with your team for approval",
    },
    {
      img: "/assest/luxury_images/gift_customisation/img1.png",
      title: "Digital Mockup",
      descn: "A digital .pdf mockup of your logo/ design on this product",
      recieveText: "2 to 48 hrs",
      reccomend:
        "you’re still ideating or want to share with your team for approval",
    },
  ];

  return (
    <section className="Personalise_Gift_Swiper">
      <div className="custom_container">
        <div className="main_content_div">
          <div className="row">
            <div className="col-lg-3">
              <div className="left_div">
                <p className="left_text">
                  Get a final look at your personalised gift before delivery.
                </p>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="swiper_div">
                <Swiper
                  spaceBetween={20}
                  slidesPerView={3}
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                      spaceBetween: 30,
                    },

                    321: {
                      slidesPerView: 1,
                      spaceBetween: 30,
                    },

                    485: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },

                    576: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },

                    765: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },

                    992: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },

                    1024: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },

                    1200: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },

                     1300: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                    
                     1400: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },

                     1500: {
                      slidesPerView: 4,
                      spaceBetween: 30,
                    },
                  }}
                  autoplay={{
                    delay: 2000, // 3 seconds delay between slides
                    disableOnInteraction: false, // allows autoplay to continue after interactions
                  }}
                  className="simple_swiper"
                >
                  {data.map((value, index) => (
                    <SwiperSlide key={index}>
                      <div className="main_card_div">
                          <div className="top_small_div">
                            <img
                              src={process.env.PUBLIC_URL + value?.img}
                              className="small_img"
                            />
                          </div>
                        <div className="gray_div">
                          <p className="title_text">{value?.title}</p>
                          <p className="descn_text">{value?.descn}</p>
                          <div className="white_div">
                            <div className="feature_div">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  icon={faClock}
                                  className="icon_text"
                                />
                              </div>
                              <div className="text_holder">
                                <p className="label_text">Receive within:</p>
                                <p className="value_text">2 to 48 hrs</p>
                              </div>
                            </div>

                            <div className="feature_div">
                              <div className="icon_holder">
                                <FontAwesomeIcon
                                  icon={faThumbsUp}
                                  className="icon_text"
                                />
                              </div>
                              <div className="text_holder">
                                <p className="label_text">Recommended if: </p>
                                <p className="value_text">
                                  you’re still ideating or want to share with
                                  your team for approval
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Personalise_Gift_Swiper;
